import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GdriveOAuthCallback',
  setup(__props) {

const success = ref(false);
const errorMessage = ref<string | null>(null);

onMounted(() => {
  // Parse params from hash fragment
  const hashParts = window.location.hash.split('?');
  const params = new URLSearchParams(hashParts[1] || '');
  const isSuccess = params.get('success') === 'true';
  const connectorId = params.get('connectorId');
  const error = params.get('error');

  if (isSuccess && connectorId) {
    success.value = true;

    // Signal to the main window via localStorage (works across same-origin windows)
    localStorage.setItem(
      'gdrive-oauth-result',
      JSON.stringify({
        success: true,
        connectorId,
        timestamp: Date.now(),
      })
    );

    setTimeout(() => window.close(), 1000);
  } else {
    errorMessage.value = error || 'Authentication failed';

    localStorage.setItem(
      'gdrive-oauth-result',
      JSON.stringify({
        success: false,
        error: errorMessage.value,
        timestamp: Date.now(),
      })
    );

    setTimeout(() => window.close(), 3000);
  }
});

return { __sfc: true,success, errorMessage }
}

})